import "./AdminCourses.css";

import React from "react";

export default function AdminCourses() {
  return (
    <div>
      <p>
        Here we mangage every kind of course, tutoring and link it to webflow
      </p>
      <p>and analysis on progress/attendance etc </p>
      <p>and materials</p>
      <p />
    </div>
  );
}
